import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerCreateEditModalComponent } from './customer-create-edit-modal.component';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    CustomerCreateEditModalComponent
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    ReactiveFormsModule,
    FormsModule,
    NgbTooltipModule
  ],
  exports: [
    CustomerCreateEditModalComponent
  ]
})
export class CustomerCreateEditModalModule { }
